import { useState, useEffect } from 'react';
import { Badge } from '@/components/ui/badge';
import { supabase } from '@/integrations/supabase/client';

export const EnvironmentBadge = () => {
  const [environment, setEnvironment] = useState<'production' | 'test' | null>(null);

  useEffect(() => {
    fetchEnvironment();

    const channel = supabase
      .channel('env_badge_changes')
      .on(
        'postgres_changes',
        {
          event: 'UPDATE',
          schema: 'public',
          table: 'stripe_settings',
        },
        (payload) => {
          const env = payload.new.environment;
          if (env === 'production' || env === 'test') {
            setEnvironment(env);
          }
        }
      )
      .subscribe();

    return () => {
      supabase.removeChannel(channel);
    };
  }, []);

  const fetchEnvironment = async () => {
    try {
      const { data } = await supabase
        .from('stripe_settings')
        .select('environment')
        .single();

      if (data && (data.environment === 'production' || data.environment === 'test')) {
        setEnvironment(data.environment);
      }
    } catch (error) {
      console.error('Error fetching environment:', error);
    }
  };

  if (!environment) return null;

  return (
    <Badge
      variant={environment === 'production' ? 'success' : 'yellow'}
    >
      {environment === 'production' ? '🟢 PROD' : '🟡 DEV'}
    </Badge>
  );
};
